module.exports = __webpack_public_path__ + "media/images/favicon-e31f61c079a00d7e91ced74f7201321a.ico";